import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LoginRequired = ({ message }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const handleLogin = () => {
    // Navigate to login with current path as redirect if possible
    const currentPath = window.location.pathname;
    // Remove language prefix if present to avoid duplication in Login component if it handles it
    const pathSegments = currentPath.split('/').filter(Boolean);
    const supportedLanguages = ['hu', 'en', 'ro', 'de', 'fr', 'es', 'it'];
    let cleanPath = currentPath;
    if (pathSegments.length > 0 && supportedLanguages.includes(pathSegments[0])) {
        cleanPath = '/' + pathSegments.slice(1).join('/');
    }

    navigate(`/${i18n.language}/login`, { state: { from: cleanPath } });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
        p: 3
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 500,
          textAlign: 'center',
          borderRadius: 2
        }}
      >
        <Typography variant="h5" gutterBottom color="primary">
          {message || t('Common.LoginRequired', 'Az ajánláshoz be kell jelentkeznie.')}
        </Typography>
        <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary' }}>
          {t('Common.LoginRequiredDescription', 'Kérjük, jelentkezzen be fiókjába, vagy regisztráljon a folytatáshoz.')}
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleLogin}
          >
            {t('Administration.LoginButton', 'Bejelentkezés')}
          </Button>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            onClick={() => navigate(`/${i18n.language}/register`)}
          >
            {t('Administration.RegisterTitle', 'Regisztráció')}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default LoginRequired;
